import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "f1bff543-ed41-46ee-99f7-16728f01ce75"
// title: "Members Header"
// type: :reference
// key: "header"
// parent_id: nil
export function HeaderF1bff543Ed4146ee99f716728f01ce75(props: any) {
  return (
    <MembersAreaHeaderOld0548d6690a6243adB811148734b32b3e parentTag="HeaderF1bff543Ed4146ee99f716728f01ce75" {...props} />
  );
}

// id: "4c18bbf6-7bb5-41c9-bf14-dbcf371fc9d1"
// title: "Page Quote"
// type: :html
// key: "page-quote"
// parent_id: nil
export function PageQuote4c18bbf67bb541c9Bf14Dbcf371fc9d1(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PageQuote4c18bbf67bb541c9Bf14Dbcf371fc9d1`}>
      <div>
      </div>
      <div>
      </div>
    </div>
  );
}

// id: "515eddab-aeba-49bf-bee3-23eba9f299a8"
// title: ""
// type: :text
// key: "imageUrl"
// parent_id: "9a40158f-f690-4804-a82b-a700ff679a3a"
export const ImageUrl515eddabAeba49bfBee323eba9f299a8 = "https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/logo-wide-white.svg";

// id: "0b884048-5314-476e-b889-52929b8e45df"
// title: ""
// type: :reference
// key: "header"
// parent_id: "09b837a8-af49-4859-a4a7-dffb76f18f3e"
export function Header0b8840485314476eB88952929b8e45df(props: any) {
  return (
    <SecondaryMarketingHeaderFf13f5ff1cc74afc9e978aca6d362f18 parentTag="Header0b8840485314476eB88952929b8e45df" title="About Susan" {...props} />
  );
}

// id: "a395263d-fd09-46a1-9873-48635843edbc"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "b9a00b21-7e82-49fc-a695-af3b462d34c9"
export function CopyrightA395263dFd0946a1987348635843edbc(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="CopyrightA395263dFd0946a1987348635843edbc" parentTag={buildClassName("CopyrightA395263dFd0946a1987348635843edbc", parentTag)} {...props} />
  );
}

// id: "7214ba75-af14-4c26-a095-025201acaaa5"
// title: "HREF"
// type: :text
// key: "href"
// parent_id: nil
export const Href7214ba75Af144c26A095025201acaaa5 = "/";

// id: "dde117f0-73c5-43e8-8689-5f5136b41668"
// title: "Secondary Page"
// type: :html
// key: "secondary-page"
// parent_id: nil
export function SecondaryPageDde117f073c543e886895f5136b41668(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryPageDde117f073c543e886895f5136b41668 gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeaderFf13f5ff1cc74afc9e978aca6d362f18 parentTag="HeaderCceb18c2Ba5449b18b345d92dbbe4d82" title="Secondary Page" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterB9a00b217e8249fcA695Af3b462d34c9 parentTag="Footer774a12726ba44062A5f2Ec68a8a32872" {...props} />}
    </div>
  );
}

// id: "ec8f9ff5-5976-4594-8026-6ddc19150db1"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "b5234aa5-2001-4982-8633-c0843a2e5631"
export function LinkedLogoEc8f9ff55976459480266ddc19150db1(props: any) {
  const Link = AppStore.presets["Link"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogoEc8f9ff55976459480266ddc19150db1" parentTag={buildClassName("LinkedLogoEc8f9ff55976459480266ddc19150db1", parentTag)} label={<DefaultLogo9a40158fF6904804A82bA700ff679a3a parentTag="Label70e84cf7D6594080B66b3b96e7e42793" alt="logo" />} className="linked-logo" url="/" {...props} />
  );
}

// id: "a667f414-a063-4a6e-ac5a-6e7f0b0a5fd4"
// title: ""
// type: :reference
// key: "header"
// parent_id: "c37d6664-4179-45dd-a3d1-b43b3612995a"
export function HeaderA667f414A0634a6eAc5a6e7f0b0a5fd4(props: any) {
  return (
    <MembersAreaHeaderOld0548d6690a6243adB811148734b32b3e parentTag="HeaderA667f414A0634a6eAc5a6e7f0b0a5fd4" {...props} />
  );
}

// id: "4507bff6-75c2-4453-a405-5ab11b37f7f2"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "b5234aa5-2001-4982-8633-c0843a2e5631"
export function Navigation4507bff675c24453A4055ab11b37f7f2(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="Navigation4507bff675c24453A4055ab11b37f7f2" parentTag={buildClassName("Navigation4507bff675c24453A4055ab11b37f7f2", parentTag)} navMenuSlug="marketing-primary-nav" className="navigation" {...props} />
  );
}

// id: "4f978918-5af2-4363-85fc-72f82d07a120"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "dd00a35b-a72e-476c-a662-17669324f3e3"
export const PostSlug4f9789185af2436385fc72f82d07a120 = "home-page-posts2";

// id: "d13eadd8-a557-40c6-87c7-7e12a6aa3b39"
// title: "Member Pages"
// type: :html
// key: "member-pages-old"
// parent_id: nil
export function MemberPagesOldD13eadd8A55740c687c77e12a6aa3b39(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const SecondaryNavigation = AppStore.presets["SecondaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MemberPagesOldD13eadd8A55740c687c77e12a6aa3b39`}>
      {props["header"] || <MembersAreaHeaderOld0548d6690a6243adB811148734b32b3e parentTag="Header036b0af06c8246589560645fdd168f7e" {...props} />}
      {props["secondary-nav"] || <SecondaryNavigation className="SecondaryNav3c621cebC9e940edBf7fD2d1cb4f710d" parentTag={buildClassName("SecondaryNav3c621cebC9e940edBf7fD2d1cb4f710d", parentTag)} {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterB9a00b217e8249fcA695Af3b462d34c9 parentTag="FooterC7e724689c1f4b1cA2bbEadadf64905d" {...props} />}
    </div>
  );
}

// id: "769bf084-2c3a-420b-b2bf-318376630914"
// title: "Resources Page"
// type: :reference
// key: "resources-page"
// parent_id: nil
export function ResourcesPage769bf0842c3a420bB2bf318376630914(props: any) {
  return (
    <SecondaryPageDde117f073c543e886895f5136b41668 parentTag="ResourcesPage769bf0842c3a420bB2bf318376630914" header={<SecondaryMarketingHeaderFf13f5ff1cc74afc9e978aca6d362f18 parentTag="Header08c096b1815946d5A519A7bac5576191" title="Resources" />} {...props} />
  );
}

// id: "188610ca-930e-403d-8863-f8e9799c8560"
// title: ""
// type: :gf_preset
// key: "hero"
// parent_id: "b711eda1-21fe-4b7a-bd32-22b963b4de32"
export function Hero188610ca930e403d8863F8e9799c8560(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Hero className="Hero188610ca930e403d8863F8e9799c8560" parentTag={buildClassName("Hero188610ca930e403d8863F8e9799c8560", parentTag)} postSlug="home-hero" {...props} />
  );
}

// id: "67d1d8b5-55c3-4ce2-bc3b-f4bffb4c5895"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "50779257-8d27-47c2-a9b2-4431370d4865"
export const NavMenuSlug67d1d8b555c34ce2Bc3bF4bffb4c5895 = "members-primary-nav";

// id: "b1d307eb-dd5e-47bc-bbf6-1e6d06d18d47"
// title: ""
// type: :reference
// key: "about-susan-header"
// parent_id: "5c0d1187-6279-4370-bd5a-a4682f2be444"
export function AboutSusanHeaderB1d307ebDd5e47bcBbf61e6d06d18d47(props: any) {
  return (
    <MembersAreaHeaderOld0548d6690a6243adB811148734b32b3e parentTag="AboutSusanHeaderB1d307ebDd5e47bcBbf61e6d06d18d47" {...props} />
  );
}

// id: "75060620-2499-4ba9-a93b-b4df5d4be877"
// title: ""
// type: :text
// key: "title"
// parent_id: "0b884048-5314-476e-b889-52929b8e45df"
export const Title7506062024994ba9A93bB4df5d4be877 = "About Susan";

// id: "b5234aa5-2001-4982-8633-c0843a2e5631"
// title: "Header Area Top"
// type: :html
// key: "default-header-top"
// parent_id: nil
export function DefaultHeaderTopB5234aa5200149828633C0843a2e5631(props: any) {
  const Link = AppStore.presets["Link"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultHeaderTopB5234aa5200149828633C0843a2e5631 header-top`}>
      {props["linked-logo"] || <Link className="LinkedLogoEc8f9ff55976459480266ddc19150db1" parentTag={buildClassName("LinkedLogoEc8f9ff55976459480266ddc19150db1", parentTag)} label={<DefaultLogo9a40158fF6904804A82bA700ff679a3a parentTag="Label70e84cf7D6594080B66b3b96e7e42793" alt="logo" />} className="linked-logo" url="/" {...props} />}
      {props["navigation"] || <PrimaryNavigation className="Navigation4507bff675c24453A4055ab11b37f7f2" parentTag={buildClassName("Navigation4507bff675c24453A4055ab11b37f7f2", parentTag)} navMenuSlug="marketing-primary-nav" className="navigation" {...props} />}
    </div>
  );
}

// id: "cb41a405-74d9-4f1e-b6f6-01b62463bb4c"
// title: "Title - Leveling"
// type: :text
// key: "title"
// parent_id: nil
export const TitleCb41a40574d94f1eB6f601b62463bb4c = "Leveling";

// id: "31605a88-a74c-437e-b0fb-967378dd631e"
// title: ""
// type: :reference
// key: "header"
// parent_id: "a5ddd4b7-ba7f-4735-a429-7a449ece0334"
export function Header31605a88A74c437eB0fb967378dd631e(props: any) {
  return (
    <SecondaryMarketingHeaderFf13f5ff1cc74afc9e978aca6d362f18 parentTag="Header31605a88A74c437eB0fb967378dd631e" title="Leveling" {...props} />
  );
}

// id: "3c621ceb-c9e9-40ed-bf7f-d2d1cb4f710d"
// title: ""
// type: :gf_preset
// key: "secondary-nav"
// parent_id: "d13eadd8-a557-40c6-87c7-7e12a6aa3b39"
export function SecondaryNav3c621cebC9e940edBf7fD2d1cb4f710d(props: any) {
  const SecondaryNavigation = AppStore.presets["SecondaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <SecondaryNavigation className="SecondaryNav3c621cebC9e940edBf7fD2d1cb4f710d" parentTag={buildClassName("SecondaryNav3c621cebC9e940edBf7fD2d1cb4f710d", parentTag)} {...props} />
  );
}

// id: "fe8f974f-1acc-4d27-859d-ab43d2cf8bba"
// title: ""
// type: :reference
// key: "header"
// parent_id: "5bac77e0-bda7-4d29-8159-91e68fe983a9"
export function HeaderFe8f974f1acc4d27859dAb43d2cf8bba(props: any) {
  return (
    <MembersAreaHeaderOld0548d6690a6243adB811148734b32b3e parentTag="HeaderFe8f974f1acc4d27859dAb43d2cf8bba" navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "ce67ad50-76c7-4592-a429-1fae4798fa80"
// title: ""
// type: :reference
// key: "label"
// parent_id: "bf3b5823-0115-4f18-8e0a-1f5ada16e19c"
export function LabelCe67ad5076c74592A4291fae4798fa80(props: any) {
  return (
    <DefaultLogo9a40158fF6904804A82bA700ff679a3a parentTag="LabelCe67ad5076c74592A4291fae4798fa80" {...props} />
  );
}

// id: "4f325235-dec2-4e71-9889-10b56c019d3b"
// title: "Marketing Cards Body"
// type: :html
// key: "marketing-body"
// parent_id: nil
export function MarketingBody4f325235Dec24e71988910b56c019d3b(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MarketingBody4f325235Dec24e71988910b56c019d3b page-body`}>
      {props["marketingCards"] || <MarketingCardsC3ab918aC9d5449eA75aD9fa4d003802 parentTag="MarketingCardsDd00a35bA72e476cA66217669324f3e3" postSlug="home-page-posts2" {...props} />}
    </div>
  );
}

// id: "1b86edb8-7dc4-4312-b5de-e8e8efc1d529"
// title: "Default Header Reference"
// type: :reference
// key: "default-header"
// parent_id: nil
export function DefaultHeader1b86edb87dc44312B5deE8e8efc1d529(props: any) {
  return (
    <SecondaryMarketingHeaderFf13f5ff1cc74afc9e978aca6d362f18 parentTag="DefaultHeader1b86edb87dc44312B5deE8e8efc1d529" title="Apply" navMenuSlug="marketing-primary-nav" {...props} />
  );
}

// id: "0f4a01d9-eb64-4460-8357-0d55736406a4"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "0653a704-d457-4b09-aa9b-74718f56cea7"
export function Navigation0f4a01d9Eb64446083570d55736406a4(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="Navigation0f4a01d9Eb64446083570d55736406a4" parentTag={buildClassName("Navigation0f4a01d9Eb64446083570d55736406a4", parentTag)} navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "625b6d37-2a06-43d1-9e3d-069a7180d0ab"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "db47151d-c8ce-483e-bdd8-f04dadabb61c"
export function Footer625b6d372a0643d19e3d069a7180d0ab(props: any) {
  return (
    <DefaultFooterB9a00b217e8249fcA695Af3b462d34c9 parentTag="Footer625b6d372a0643d19e3d069a7180d0ab" {...props} />
  );
}

// id: "b144fea0-9483-4f60-8126-8609fe0f78da"
// title: ""
// type: :text
// key: "title"
// parent_id: "1b86edb8-7dc4-4312-b5de-e8e8efc1d529"
export const TitleB144fea094834f6081268609fe0f78da = "Apply";

// id: "fa1d0c93-0cbc-4f13-a7cd-3f0b37388a6a"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "4507bff6-75c2-4453-a405-5ab11b37f7f2"
export const NavMenuSlugFa1d0c930cbc4f13A7cd3f0b37388a6a = "marketing-primary-nav";

// id: "a5ddd4b7-ba7f-4735-a429-7a449ece0334"
// title: "Levels 1-4 Explained"
// type: :html
// key: "about-leveling-page"
// parent_id: nil
export function AboutLevelingPageA5ddd4b7Ba7f4735A4297a449ece0334(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutLevelingPageA5ddd4b7Ba7f4735A4297a449ece0334`}>
      {props["header"] || <SecondaryMarketingHeaderFf13f5ff1cc74afc9e978aca6d362f18 parentTag="Header31605a88A74c437eB0fb967378dd631e" title="Leveling" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterB9a00b217e8249fcA695Af3b462d34c9 parentTag="Footer8574ba822bbf431fB71491021a2f440c" {...props} />}
    </div>
  );
}

// id: "91cc17df-7a76-41da-a6a9-f1dacfec7234"
// title: "Label"
// type: :reference
// key: "label"
// parent_id: nil
export function Label91cc17df7a7641daA6a9F1dacfec7234(props: any) {
  return (
    <DefaultLogo9a40158fF6904804A82bA700ff679a3a parentTag="Label91cc17df7a7641daA6a9F1dacfec7234" {...props} />
  );
}

// id: "774a1272-6ba4-4062-a5f2-ec68a8a32872"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "dde117f0-73c5-43e8-8689-5f5136b41668"
export function Footer774a12726ba44062A5f2Ec68a8a32872(props: any) {
  return (
    <DefaultFooterB9a00b217e8249fcA695Af3b462d34c9 parentTag="Footer774a12726ba44062A5f2Ec68a8a32872" {...props} />
  );
}

// id: "64937f15-f98d-4dc3-ab4e-33d2dae1ddcd"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "b9a00b21-7e82-49fc-a695-af3b462d34c9"
export function Groupflow64937f15F98d4dc3Ab4e33d2dae1ddcd(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow64937f15F98d4dc3Ab4e33d2dae1ddcd" parentTag={buildClassName("Groupflow64937f15F98d4dc3Ab4e33d2dae1ddcd", parentTag)} {...props} />
  );
}

// id: "33717523-c629-4c07-8377-7714c3c75039"
// title: ""
// type: :text
// key: "class"
// parent_id: "69aad7fa-ffa5-4475-9daf-462bae21f146"
export const Class33717523C6294c0783777714c3c75039 = "join-us";

// id: "fc821265-35b0-4ce5-9800-9d9a5d2fb2d2"
// title: ""
// type: :text
// key: "title"
// parent_id: "db95b151-1481-480d-b1a8-b8dd98356abe"
export const TitleFc82126535b04ce598009d9a5d2fb2d2 = "Join Us";

// id: "3a700b3e-c552-46c5-8fc1-e625486e3bb6"
// title: "Signup Pages"
// type: :reference
// key: "signup-pages"
// parent_id: nil
export function SignupPages3a700b3eC55246c58fc1E625486e3bb6(props: any) {
  return (
    <SecondaryPageDde117f073c543e886895f5136b41668 parentTag="SignupPages3a700b3eC55246c58fc1E625486e3bb6" header={<SecondaryMarketingHeaderFf13f5ff1cc74afc9e978aca6d362f18 parentTag="HeaderDb95b1511481480dB1a8B8dd98356abe" title="Join Us" />} {...props} />
  );
}

// id: "9a40158f-f690-4804-a82b-a700ff679a3a"
// title: "Logo"
// type: :html
// key: "default-logo"
// parent_id: nil
export function DefaultLogo9a40158fF6904804A82bA700ff679a3a(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/logo-wide-white.svg" className={`${parentTag || ""} DefaultLogo9a40158fF6904804A82bA700ff679a3a logo`} alt="logo" />
  );
}

// id: "a1d0821b-cb49-476f-a458-02d5c9d2a313"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "b711eda1-21fe-4b7a-bd32-22b963b4de32"
export function HeaderTopA1d0821bCb49476fA45802d5c9d2a313(props: any) {
  return (
    <DefaultHeaderTopB5234aa5200149828633C0843a2e5631 parentTag="HeaderTopA1d0821bCb49476fA45802d5c9d2a313" {...props} />
  );
}

// id: "08c096b1-8159-46d5-a519-a7bac5576191"
// title: ""
// type: :reference
// key: "header"
// parent_id: "769bf084-2c3a-420b-b2bf-318376630914"
export function Header08c096b1815946d5A519A7bac5576191(props: any) {
  return (
    <SecondaryMarketingHeaderFf13f5ff1cc74afc9e978aca6d362f18 parentTag="Header08c096b1815946d5A519A7bac5576191" title="Resources" {...props} />
  );
}

// id: "cceb18c2-ba54-49b1-8b34-5d92dbbe4d82"
// title: ""
// type: :reference
// key: "header"
// parent_id: "dde117f0-73c5-43e8-8689-5f5136b41668"
export function HeaderCceb18c2Ba5449b18b345d92dbbe4d82(props: any) {
  return (
    <SecondaryMarketingHeaderFf13f5ff1cc74afc9e978aca6d362f18 parentTag="HeaderCceb18c2Ba5449b18b345d92dbbe4d82" title="Secondary Page" {...props} />
  );
}

// id: "70e84cf7-d659-4080-b66b-3b96e7e42793"
// title: ""
// type: :reference
// key: "label"
// parent_id: "ec8f9ff5-5976-4594-8026-6ddc19150db1"
export function Label70e84cf7D6594080B66b3b96e7e42793(props: any) {
  return (
    <DefaultLogo9a40158fF6904804A82bA700ff679a3a parentTag="Label70e84cf7D6594080B66b3b96e7e42793" {...props} />
  );
}

// id: "a8475aa2-dc80-4f1e-8713-62bfc4a29b72"
// title: "Public Events Page"
// type: :html
// key: "public-events-page"
// parent_id: nil
export function PublicEventsPageA8475aa2Dc804f1e871362bfc4a29b72(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicEventsPageA8475aa2Dc804f1e871362bfc4a29b72`}>
      {props["header"] || <SecondaryMarketingHeaderFf13f5ff1cc74afc9e978aca6d362f18 parentTag="Header85c50bb1Cd194dafA90fC0eeaca4365c" title="Public Events" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterB9a00b217e8249fcA695Af3b462d34c9 parentTag="Footer3b5faa7848bb43b3A6f99926730e4eb3" {...props} />}
    </div>
  );
}

// id: "4819020d-d610-438b-8756-703ad978c965"
// title: "Common Footer"
// type: :reference
// key: "footer"
// parent_id: nil
export function Footer4819020dD610438b8756703ad978c965(props: any) {
  return (
    <DefaultFooterB9a00b217e8249fcA695Af3b462d34c9 parentTag="Footer4819020dD610438b8756703ad978c965" {...props} />
  );
}

// id: "db95b151-1481-480d-b1a8-b8dd98356abe"
// title: ""
// type: :reference
// key: "header"
// parent_id: "3a700b3e-c552-46c5-8fc1-e625486e3bb6"
export function HeaderDb95b1511481480dB1a8B8dd98356abe(props: any) {
  return (
    <SecondaryMarketingHeaderFf13f5ff1cc74afc9e978aca6d362f18 parentTag="HeaderDb95b1511481480dB1a8B8dd98356abe" title="Join Us" {...props} />
  );
}

// id: "f6c6f806-c06c-4dc5-98f7-42b1d0763833"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "b9a00b21-7e82-49fc-a695-af3b462d34c9"
export function LinksF6c6f806C06c4dc598f742b1d0763833(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="LinksF6c6f806C06c4dc598f742b1d0763833" parentTag={buildClassName("LinksF6c6f806C06c4dc598f742b1d0763833", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "712b1506-c6f2-4dc0-87ed-f04cf71ea86c"
// title: "Marketing Primary Navigation"
// type: :text
// key: "navMenuSlug"
// parent_id: "1b86edb8-7dc4-4312-b5de-e8e8efc1d529"
export const NavMenuSlug712b1506C6f24dc087edF04cf71ea86c = "marketing-primary-nav";

// id: "e7956cc5-d568-46e4-bbe1-e6e304e1ad5e"
// title: "Members Area Navigation"
// type: :gf_preset
// key: "navigation"
// parent_id: "036b0af0-6c82-4658-9560-645fdd168f7e"
export function NavigationE7956cc5D56846e4Bbe1E6e304e1ad5e(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="NavigationE7956cc5D56846e4Bbe1E6e304e1ad5e" parentTag={buildClassName("NavigationE7956cc5D56846e4Bbe1E6e304e1ad5e", parentTag)} className="navigation" {...props} />
  );
}

// id: "f1bf4a81-c5af-4023-a0ff-abd8a030fd01"
// title: "Secondary Marketing Hero"
// type: :html
// key: "secondary-marketing-hero"
// parent_id: nil
export function SecondaryMarketingHeroF1bf4a81C5af4023A0ffAbd8a030fd01(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeroF1bf4a81C5af4023A0ffAbd8a030fd01 hero`}>
      <div className="title">
        {props["title"] || TitleE2af129bB74f4574A469A64caf91a0da}
      </div>
    </div>
  );
}

// id: "5bac77e0-bda7-4d29-8159-91e68fe983a9"
// title: "Members Area"
// type: :html
// key: "members-area-default"
// parent_id: nil
export function MembersAreaDefault5bac77e0Bda74d29815991e68fe983a9(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MembersAreaDefault5bac77e0Bda74d29815991e68fe983a9 page`}>
      {props["header"] || <MembersAreaHeaderOld0548d6690a6243adB811148734b32b3e parentTag="HeaderFe8f974f1acc4d27859dAb43d2cf8bba" navMenuSlug="members-primary-nav" {...props} />}
      {props["footer"] || <DefaultFooterB9a00b217e8249fcA695Af3b462d34c9 parentTag="Footer69a9596e8f54414fAbbbDcdce21d3c53" {...props} />}
    </div>
  );
}

// id: "e8b4400d-95bc-4099-8e6c-dca572de4683"
// title: ""
// type: :text
// key: "title"
// parent_id: "ff13f5ff-1cc7-4afc-9e97-8aca6d362f18"
export const TitleE8b4400d95bc40998e6cDca572de4683 = "Secondary Marketing Title 1";

// id: "5e72c7da-244a-4021-a075-cf6b5324633e"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "c3ab918a-c9d5-449e-a75a-d9fa4d003802"
export const PostSlug5e72c7da244a4021A075Cf6b5324633e = "home-page-posts2";

// id: "86173d90-44ad-40e9-8d81-604d7f342d83"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "5c0d1187-6279-4370-bd5a-a4682f2be444"
export function Footer86173d9044ad40e98d81604d7f342d83(props: any) {
  return (
    <DefaultFooterB9a00b217e8249fcA695Af3b462d34c9 parentTag="Footer86173d9044ad40e98d81604d7f342d83" {...props} />
  );
}

// id: "29efaffe-e5ae-49f2-a327-0da81d392200"
// title: ""
// type: :text
// key: "class"
// parent_id: "ec8f9ff5-5976-4594-8026-6ddc19150db1"
export const Class29efaffeE5ae49f2A3270da81d392200 = "linked-logo";

// id: "50779257-8d27-47c2-a9b2-4431370d4865"
// title: "About SuSun"
// type: :html
// key: "about-susan"
// parent_id: nil
export function AboutSusan507792578d2747c2A9b24431370d4865(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutSusan507792578d2747c2A9b24431370d4865`} navMenuSlug="members-primary-nav">
      {props["about-susan-header"] || <MembersAreaHeaderOld0548d6690a6243adB811148734b32b3e parentTag="AboutSusanHeader8241ed2e83c14846B14b568a9a24c9ca" {...props} />}
      {props["about-susan-main"] || <AboutSusanMain3cc8fcb526e94b89886aE1945fc8721e />}
      {props["footer"] || <DefaultFooterB9a00b217e8249fcA695Af3b462d34c9 parentTag="Footer43b58726A1dd4aa7B6508e36196c85b4" {...props} />}
    </div>
  );
}

// id: "b9a00b21-7e82-49fc-a695-af3b462d34c9"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooterB9a00b217e8249fcA695Af3b462d34c9(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooterB9a00b217e8249fcA695Af3b462d34c9 footer`}>
      {props["links"] || <Navigation className="LinksF6c6f806C06c4dc598f742b1d0763833" parentTag={buildClassName("LinksF6c6f806C06c4dc598f742b1d0763833", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo0f83c49f9a904a9d99fc33d0d04e8d42 />}
      </div>
      {props["copyright"] || <GroupCopyright className="CopyrightA395263dFd0946a1987348635843edbc" parentTag={buildClassName("CopyrightA395263dFd0946a1987348635843edbc", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow64937f15F98d4dc3Ab4e33d2dae1ddcd" parentTag={buildClassName("Groupflow64937f15F98d4dc3Ab4e33d2dae1ddcd", parentTag)} {...props} />}
    </footer>
  );
}

// id: "43b58726-a1dd-4aa7-b650-8e36196c85b4"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "50779257-8d27-47c2-a9b2-4431370d4865"
export function Footer43b58726A1dd4aa7B6508e36196c85b4(props: any) {
  return (
    <DefaultFooterB9a00b217e8249fcA695Af3b462d34c9 parentTag="Footer43b58726A1dd4aa7B6508e36196c85b4" {...props} />
  );
}

// id: "e2af129b-b74f-4574-a469-a64caf91a0da"
// title: ""
// type: :text
// key: "title"
// parent_id: "f1bf4a81-c5af-4023-a0ff-abd8a030fd01"
export const TitleE2af129bB74f4574A469A64caf91a0da = "Default Title";

// id: "036b0af0-6c82-4658-9560-645fdd168f7e"
// title: ""
// type: :reference
// key: "header"
// parent_id: "d13eadd8-a557-40c6-87c7-7e12a6aa3b39"
export function Header036b0af06c8246589560645fdd168f7e(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  return (
    <MembersAreaHeaderOld0548d6690a6243adB811148734b32b3e parentTag="Header036b0af06c8246589560645fdd168f7e" {...props} />
  );
}

// id: "098a96ae-f18e-4e00-b9fd-d492c811497a"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "33f21fb5-8bf5-4a78-b70d-26bba085a133"
export const PostSlug098a96aeF18e4e00B9fdD492c811497a = "about-us-posts";

// id: "c37d6664-4179-45dd-a3d1-b43b3612995a"
// title: "Message Pages"
// type: :html
// key: "message-pages"
// parent_id: nil
export function MessagePagesC37d6664417945ddA3d1B43b3612995a(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MessagePagesC37d6664417945ddA3d1B43b3612995a`}>
      {props["header"] || <MembersAreaHeaderOld0548d6690a6243adB811148734b32b3e parentTag="HeaderA667f414A0634a6eAc5a6e7f0b0a5fd4" {...props} />}
      {props.children}
    </div>
  );
}

// id: "b711eda1-21fe-4b7a-bd32-22b963b4de32"
// title: "Home Header"
// type: :html
// key: "home-header"
// parent_id: nil
export function HomeHeaderB711eda121fe4b7aBd3222b963b4de32(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomeHeaderB711eda121fe4b7aBd3222b963b4de32 site-header`}>
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopB5234aa5200149828633C0843a2e5631 parentTag="HeaderTopA1d0821bCb49476fA45802d5c9d2a313" {...props} />}
      </div>
      <div className="relative hero-wrapper">
        <div className="background-image" />
        {props["hero"] || <Hero className="Hero188610ca930e403d8863F8e9799c8560" parentTag={buildClassName("Hero188610ca930e403d8863F8e9799c8560", parentTag)} postSlug="home-hero" {...props} />}
      </div>
    </div>
  );
}

// id: "33f21fb5-8bf5-4a78-b70d-26bba085a133"
// title: ""
// type: :reference
// key: "body"
// parent_id: "09b837a8-af49-4859-a4a7-dffb76f18f3e"
export function Body33f21fb58bf54a78B70d26bba085a133(props: any) {
  return (
    <MarketingBody4f325235Dec24e71988910b56c019d3b parentTag="Body33f21fb58bf54a78B70d26bba085a133" postSlug="about-us-posts" {...props} />
  );
}

// id: "dd00a35b-a72e-476c-a662-17669324f3e3"
// title: ""
// type: :reference
// key: "marketingCards"
// parent_id: "4f325235-dec2-4e71-9889-10b56c019d3b"
export function MarketingCardsDd00a35bA72e476cA66217669324f3e3(props: any) {
  return (
    <MarketingCardsC3ab918aC9d5449eA75aD9fa4d003802 parentTag="MarketingCardsDd00a35bA72e476cA66217669324f3e3" postSlug="home-page-posts2" {...props} />
  );
}

// id: "6d598c8a-4170-4c71-a8a0-a0f2dd658270"
// title: ""
// type: :text
// key: "class"
// parent_id: "4507bff6-75c2-4453-a405-5ab11b37f7f2"
export const Class6d598c8a41704c71A8a0A0f2dd658270 = "navigation";

// id: "74974fdd-06c4-46a7-b42a-467ba73e0764"
// title: ""
// type: :text
// key: "title"
// parent_id: "85c50bb1-cd19-4daf-a90f-c0eeaca4365c"
export const Title74974fdd06c446a7B42a467ba73e0764 = "Public Events";

// id: "9147cb14-1940-4755-90fb-2a8679bd6409"
// title: "Admin Pages"
// type: :html
// key: "admin-pages"
// parent_id: nil
export function AdminPages9147cb141940475590fb2a8679bd6409(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AdminPages9147cb141940475590fb2a8679bd6409`}>
      {props.children}
    </div>
  );
}

// id: "0548d669-0a62-43ad-b811-148734b32b3e"
// title: "Members Area Header"
// type: :reference
// key: "members-area-header-old"
// parent_id: nil
export function MembersAreaHeaderOld0548d6690a6243adB811148734b32b3e(props: any) {
  return (
    <DefaultHeaderTopB5234aa5200149828633C0843a2e5631 parentTag="MembersAreaHeaderOld0548d6690a6243adB811148734b32b3e" navMenuSlug="members-primary-nav" header-top={<DefaultHeaderTopB5234aa5200149828633C0843a2e5631 parentTag="HeaderTopC2b32e8eB6354154A71f673669341357" navMenuSlug="members-primary-nav" />} {...props} />
  );
}

// id: "12534a71-868d-4dd9-ac99-48938e74401d"
// title: ""
// type: :gf_preset
// key: "welcome-back"
// parent_id: "db47151d-c8ce-483e-bdd8-f04dadabb61c"
export function WelcomeBack12534a71868d4dd9Ac9948938e74401d(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <WelcomeBackPopUp className="WelcomeBack12534a71868d4dd9Ac9948938e74401d" parentTag={buildClassName("WelcomeBack12534a71868d4dd9Ac9948938e74401d", parentTag)} {...props} />
  );
}

// id: "908c3210-6779-438b-946d-3325ecfe7deb"
// title: ""
// type: :reference
// key: "hero"
// parent_id: "ff13f5ff-1cc7-4afc-9e97-8aca6d362f18"
export function Hero908c32106779438b946d3325ecfe7deb(props: any) {
  return (
    <SecondaryMarketingHeroF1bf4a81C5af4023A0ffAbd8a030fd01 parentTag="Hero908c32106779438b946d3325ecfe7deb" title="Secondary Marketing Title 2" {...props} />
  );
}

// id: "8acb1836-df3d-4f4f-9b17-00b34517d2ad"
// title: ""
// type: :text
// key: "title"
// parent_id: "08c096b1-8159-46d5-a519-a7bac5576191"
export const Title8acb1836Df3d4f4f9b1700b34517d2ad = "Resources";

// id: "db0e1889-f1b4-4e2e-9250-77af53fc0e11"
// title: ""
// type: :text
// key: "label"
// parent_id: "5eabdceb-494b-4871-b346-6c626151af9b"
export const LabelDb0e1889F1b44e2e925077af53fc0e11 = "Join Us";

// id: "034360cc-e2fe-4d38-9d08-a7c120f73d74"
// title: "Home Page Hero"
// type: :html
// key: "home-page-hero"
// parent_id: nil
export function HomePageHero034360ccE2fe4d389d08A7c120f73d74(props: any) {
  const Button = AppStore.presets["Button"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePageHero034360ccE2fe4d389d08A7c120f73d74 hero`}>
      <div className="title">
        Remember you are the Magic
      </div>
      <div className="button">
        {props["button"] || <Button className="Button5eabdceb494b4871B3466c626151af9b" parentTag={buildClassName("Button5eabdceb494b4871B3466c626151af9b", parentTag)} label="Join Us" href="/join" {...props} />}
      </div>
    </div>
  );
}

// id: "0f83c49f-9a90-4a9d-99fc-33d0d04e8d42"
// title: ""
// type: :html
// key: "logo"
// parent_id: "b9a00b21-7e82-49fc-a695-af3b462d34c9"
export function Logo0f83c49f9a904a9d99fc33d0d04e8d42(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/logo-wide-white.svg" alt="Demo 1 logo" className={`${parentTag || ""} Logo0f83c49f9a904a9d99fc33d0d04e8d42 logo`} />
  );
}

// id: "69a9596e-8f54-414f-abbb-dcdce21d3c53"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "5bac77e0-bda7-4d29-8159-91e68fe983a9"
export function Footer69a9596e8f54414fAbbbDcdce21d3c53(props: any) {
  return (
    <DefaultFooterB9a00b217e8249fcA695Af3b462d34c9 parentTag="Footer69a9596e8f54414fAbbbDcdce21d3c53" {...props} />
  );
}

// id: "3b5faa78-48bb-43b3-a6f9-9926730e4eb3"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "a8475aa2-dc80-4f1e-8713-62bfc4a29b72"
export function Footer3b5faa7848bb43b3A6f99926730e4eb3(props: any) {
  return (
    <DefaultFooterB9a00b217e8249fcA695Af3b462d34c9 parentTag="Footer3b5faa7848bb43b3A6f99926730e4eb3" {...props} />
  );
}

// id: "7abee52b-a7d9-46bf-ab4e-17a34e9f614e"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "ac510ae1-aff0-4ecd-8cec-be2cf50d5029"
export const ContentSlug7abee52bA7d946bfAb4e17a34e9f614e = "home-page-quote";

// id: "436925b1-eabd-40be-acfc-df9ab5db1a51"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "f6c6f806-c06c-4dc5-98f7-42b1d0763833"
export const NavMenuSlug436925b1Eabd40beAcfcDf9ab5db1a51 = "footer-nav";

// id: "5c0d1187-6279-4370-bd5a-a4682f2be444"
// title: "Offerings"
// type: :html
// key: "about-offerings"
// parent_id: nil
export function AboutOfferings5c0d118762794370Bd5aA4682f2be444(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutOfferings5c0d118762794370Bd5aA4682f2be444`}>
      {props["about-susan-header"] || <MembersAreaHeaderOld0548d6690a6243adB811148734b32b3e parentTag="AboutSusanHeaderB1d307ebDd5e47bcBbf61e6d06d18d47" {...props} />}
      <main>
        <div>
          <div className="gf-cols-2 content-width">
            <div className="image">
              <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/images/altar.webp" alt="Altar" className="block-image" />
            </div>
            <div className="text-block-vertical">
              <div className="heading">
                What to expect from a session
              </div>
              <ul>
                <li>
                  Reduced stress and anxiety
                </li>
                <li>
                  Increased energetic awareness
                </li>
                <li>
                  Develop more compassion for yourself and others
                </li>
                <li>
                  More capacity to live the life of your dreams
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="hero brave">
          <div className="text-block text-block-vertical content-width">
            <div className="heading">
              You&#39;re so brave for showing up!
            </div>
            <p>
              Humans come to me for a variety of different reasons. Healing is a
              very unique journey for everyone. I want to highlight my different
              offerings, yet create space to co-create something perfect for you.
            </p>
          </div>
        </div>
        <div>
          <div className="grid-blocks content-width">
            <div className="image-text-block">
              <div className="image">
                <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/images/susan-massage.webp" alt="SuSun massage" />
              </div>
              <div className="text">
                <div className="heading">
                  Tantric Awakening
                </div>
                <p>
                  Feel more in your body.
                </p>
                <p>
                  More pleasure. More space. More freedom.
                </p>
                <p>
                  Allow yourself to relax, receive, and enjoy.
                </p>
              </div>
            </div>
            <div className="image-text-block">
              <div className="image">
                <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/images/pray-art.webp" alt="Chakra" />
              </div>
              <div className="text">
                <div className="heading">
                  Chakra Alignment
                </div>
                <p>
                  Clear out stagnant energy, quiet the noise.
                </p>
                <p>
                  Through Reiki we can prepare your energetic body for a vibrational
                  shift.
                </p>
                <p>
                  Increased intuitive awareness and psychic sensitivity.
                </p>
              </div>
            </div>
            <div className="image-text-block">
              <div className="image">
                <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/images/sacred-foot.webp" alt="Kinky Tasting" />
              </div>
              <div className="text">
                <div className="heading">
                  Kinky Tasting
                </div>
                <p>
                  Do you have an itch to explore?
                </p>
                <p>
                  Something you have always wanted to try?
                </p>
                <p>
                  Let&#39;s get a taste of those passions you may be a bit shy to talk
                  about.
                </p>
                <p>
                  Through consent, negotiation and boundaries we can explore in new
                  ways.
                </p>
              </div>
            </div>
            <div className="image-text-block">
              <div className="image">
                <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/images/susan-guiding.webp" alt="SuSun guiding a student" />
              </div>
              <div className="text">
                <div className="heading">
                  Becoming Sex-Positive
                </div>
                <p>
                  Build your communication skills, knowledge and understanding.
                </p>
                <p>
                  Learn your somatic YES, body awareness and the confidence to bring
                  all of yourself into community.
                </p>
                <p>
                  Take a road trip into new and exciting ways of being in
                  relationship.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <a href="/members/messages/x1RwUD7TogtZzODN" className="Button">
            Walking with me
          </a>
        </div>
      </main>
      {props["footer"] || <DefaultFooterB9a00b217e8249fcA695Af3b462d34c9 parentTag="Footer86173d9044ad40e98d81604d7f342d83" {...props} />}
    </div>
  );
}

// id: "a6cce985-4b40-4d3a-837b-4c5a277a4177"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "0548d669-0a62-43ad-b811-148734b32b3e"
export const NavMenuSlugA6cce9854b404d3a837b4c5a277a4177 = "members-primary-nav";

// id: "ecc3deda-fc13-4e4e-832a-86ce938f64fc"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "ff13f5ff-1cc7-4afc-9e97-8aca6d362f18"
export function HeaderTopEcc3dedaFc134e4e832a86ce938f64fc(props: any) {
  return (
    <DefaultHeaderTopB5234aa5200149828633C0843a2e5631 parentTag="HeaderTopEcc3dedaFc134e4e832a86ce938f64fc" {...props} />
  );
}

// id: "4c686644-d5e4-4631-87ec-2fb55a431764"
// title: ""
// type: :reference
// key: "body"
// parent_id: "db47151d-c8ce-483e-bdd8-f04dadabb61c"
export function Body4c686644D5e4463187ec2fb55a431764(props: any) {
  return (
    <MarketingBody4f325235Dec24e71988910b56c019d3b parentTag="Body4c686644D5e4463187ec2fb55a431764" {...props} />
  );
}

// id: "031cd02b-39bf-4e12-a8cb-693e50614586"
// title: ""
// type: :text
// key: "url"
// parent_id: "ec8f9ff5-5976-4594-8026-6ddc19150db1"
export const Url031cd02b39bf4e12A8cb693e50614586 = "/";

// id: "e5cadda3-300c-4bba-a60e-33221300c53a"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "fe8f974f-1acc-4d27-859d-ab43d2cf8bba"
export const NavMenuSlugE5cadda3300c4bbaA60e33221300c53a = "members-primary-nav";

// id: "ff13f5ff-1cc7-4afc-9e97-8aca6d362f18"
// title: "Secondary Marketing Header"
// type: :html
// key: "secondary-marketing-header"
// parent_id: nil
export function SecondaryMarketingHeaderFf13f5ff1cc74afc9e978aca6d362f18(props: any) {
  const { parentTag, ...rest } = props;
  props = { title: "Secondary Marketing Title 1", ...rest };
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeaderFf13f5ff1cc74afc9e978aca6d362f18 site-header`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopB5234aa5200149828633C0843a2e5631 parentTag="HeaderTopEcc3dedaFc134e4e832a86ce938f64fc" {...props} />}
      </div>
      {props["hero"] || <SecondaryMarketingHeroF1bf4a81C5af4023A0ffAbd8a030fd01 parentTag="Hero908c32106779438b946d3325ecfe7deb" title="Secondary Marketing Title 2" {...props} />}
    </div>
  );
}

// id: "9b29935e-3ae3-4e1a-ac89-39632a8603c7"
// title: ""
// type: :reference
// key: "header"
// parent_id: "db47151d-c8ce-483e-bdd8-f04dadabb61c"
export function Header9b29935e3ae34e1aAc8939632a8603c7(props: any) {
  return (
    <HomeHeaderB711eda121fe4b7aBd3222b963b4de32 parentTag="Header9b29935e3ae34e1aAc8939632a8603c7" {...props} />
  );
}

// id: "bf3b5823-0115-4f18-8e0a-1f5ada16e19c"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "0653a704-d457-4b09-aa9b-74718f56cea7"
export function LinkedLogoBf3b582301154f188e0a1f5ada16e19c(props: any) {
  const Link = AppStore.presets["Link"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogoBf3b582301154f188e0a1f5ada16e19c" parentTag={buildClassName("LinkedLogoBf3b582301154f188e0a1f5ada16e19c", parentTag)} label={<DefaultLogo9a40158fF6904804A82bA700ff679a3a parentTag="LabelCe67ad5076c74592A4291fae4798fa80" alt="logo" />} {...props} />
  );
}

// id: "85c50bb1-cd19-4daf-a90f-c0eeaca4365c"
// title: ""
// type: :reference
// key: "header"
// parent_id: "a8475aa2-dc80-4f1e-8713-62bfc4a29b72"
export function Header85c50bb1Cd194dafA90fC0eeaca4365c(props: any) {
  return (
    <SecondaryMarketingHeaderFf13f5ff1cc74afc9e978aca6d362f18 parentTag="Header85c50bb1Cd194dafA90fC0eeaca4365c" title="Public Events" {...props} />
  );
}

// id: "c021d4dd-dd44-4040-93ec-0ae8e146e41f"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "0f4a01d9-eb64-4460-8357-0d55736406a4"
export const NavMenuSlugC021d4ddDd44404093ec0ae8e146e41f = "members-primary-nav";

// id: "5e225e74-c0b4-4ce0-b8b6-1d4365d44acb"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "c2b32e8e-b635-4154-a71f-673669341357"
export const NavMenuSlug5e225e74C0b44ce0B8b61d4365d44acb = "members-primary-nav";

// id: "69aad7fa-ffa5-4475-9daf-462bae21f146"
// title: "Join Us Page"
// type: :reference
// key: "join-us-page"
// parent_id: nil
export function JoinUsPage69aad7faFfa544759daf462bae21f146(props: any) {
  return (
    <SecondaryPageDde117f073c543e886895f5136b41668 parentTag="JoinUsPage69aad7faFfa544759daf462bae21f146" className="join-us" header={<SecondaryMarketingHeaderFf13f5ff1cc74afc9e978aca6d362f18 parentTag="HeaderF81cfd1506fe4d31B478964e25ca82f9" title="Join Us" />} {...props} />
  );
}

// id: "ac510ae1-aff0-4ecd-8cec-be2cf50d5029"
// title: ""
// type: :gf_preset
// key: "quote"
// parent_id: "db47151d-c8ce-483e-bdd8-f04dadabb61c"
export function QuoteAc510ae1Aff04ecd8cecBe2cf50d5029(props: any) {
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageQuote className="QuoteAc510ae1Aff04ecd8cecBe2cf50d5029" parentTag={buildClassName("QuoteAc510ae1Aff04ecd8cecBe2cf50d5029", parentTag)} contentSlug="home-page-quote" {...props} />
  );
}

// id: "c2b32e8e-b635-4154-a71f-673669341357"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "0548d669-0a62-43ad-b811-148734b32b3e"
export function HeaderTopC2b32e8eB6354154A71f673669341357(props: any) {
  return (
    <DefaultHeaderTopB5234aa5200149828633C0843a2e5631 parentTag="HeaderTopC2b32e8eB6354154A71f673669341357" navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "22e94947-65f3-4eaa-ae11-808ddc995016"
// title: ""
// type: :text
// key: "title"
// parent_id: "908c3210-6779-438b-946d-3325ecfe7deb"
export const Title22e9494765f34eaaAe11808ddc995016 = "Secondary Marketing Title 2";

// id: "5321731b-6887-4811-bbbd-01f7e7a5f86e"
// title: ""
// type: :text
// key: "class"
// parent_id: "e7956cc5-d568-46e4-bbe1-e6e304e1ad5e"
export const Class5321731b68874811Bbbd01f7e7a5f86e = "navigation";

// id: "09b837a8-af49-4859-a4a7-dffb76f18f3e"
// title: "About Us"
// type: :html
// key: "about-us-page"
// parent_id: nil
export function AboutUsPage09b837a8Af494859A4a7Dffb76f18f3e(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutUsPage09b837a8Af494859A4a7Dffb76f18f3e page`}>
      {props["header"] || <SecondaryMarketingHeaderFf13f5ff1cc74afc9e978aca6d362f18 parentTag="Header0b8840485314476eB88952929b8e45df" title="About Susan" {...props} />}
      <main className="main">
        About Susan - TBD
      </main>
      {props["footer"] || <DefaultFooterB9a00b217e8249fcA695Af3b462d34c9 parentTag="FooterFbc31c34583744e6B5f7B2cd1925d497" {...props} />}
    </div>
  );
}

// id: "d3a0e07f-f702-4472-b12f-80a85b8c0a95"
// title: ""
// type: :text
// key: "backgroundImage"
// parent_id: "0653a704-d457-4b09-aa9b-74718f56cea7"
export const BackgroundImageD3a0e07fF7024472B12f80a85b8c0a95 = "https://mp1md-pub.s3.amazonaws.com/orgs/sample/city-background.jpg";

// id: "8574ba82-2bbf-431f-b714-91021a2f440c"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "a5ddd4b7-ba7f-4735-a429-7a449ece0334"
export function Footer8574ba822bbf431fB71491021a2f440c(props: any) {
  return (
    <DefaultFooterB9a00b217e8249fcA695Af3b462d34c9 parentTag="Footer8574ba822bbf431fB71491021a2f440c" {...props} />
  );
}

// id: "ef11f2a0-37a5-4206-adfc-286089568307"
// title: ""
// type: :text
// key: "buttonClass"
// parent_id: "c3ab918a-c9d5-449e-a75a-d9fa4d003802"
export const ButtonClassEf11f2a037a54206Adfc286089568307 = "inline-block px-12 py-3 hover:brightness-110 transition duration";

// id: "be6a53f4-5c06-41a3-9a83-3bf0189bac33"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "188610ca-930e-403d-8863-f8e9799c8560"
export const PostSlugBe6a53f45c0641a39a833bf0189bac33 = "home-hero";

// id: "0653a704-d457-4b09-aa9b-74718f56cea7"
// title: "Short Header"
// type: :html
// key: "short-header"
// parent_id: nil
export function ShortHeader0653a704D4574b09Aa9b74718f56cea7(props: any) {
  const Link = AppStore.presets["Link"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} ShortHeader0653a704D4574b09Aa9b74718f56cea7 site-header`}>
      <div className="background-image" />
      <div className="header-top">
        {props["linked-logo"] || <Link className="LinkedLogoBf3b582301154f188e0a1f5ada16e19c" parentTag={buildClassName("LinkedLogoBf3b582301154f188e0a1f5ada16e19c", parentTag)} label={<DefaultLogo9a40158fF6904804A82bA700ff679a3a parentTag="LabelCe67ad5076c74592A4291fae4798fa80" alt="logo" />} {...props} />}
        {props["navigation"] || <PrimaryNavigation className="Navigation0f4a01d9Eb64446083570d55736406a4" parentTag={buildClassName("Navigation0f4a01d9Eb64446083570d55736406a4", parentTag)} navMenuSlug="members-primary-nav" {...props} />}
      </div>
    </div>
  );
}

// id: "8241ed2e-83c1-4846-b14b-568a9a24c9ca"
// title: ""
// type: :reference
// key: "about-susan-header"
// parent_id: "50779257-8d27-47c2-a9b2-4431370d4865"
export function AboutSusanHeader8241ed2e83c14846B14b568a9a24c9ca(props: any) {
  return (
    <MembersAreaHeaderOld0548d6690a6243adB811148734b32b3e parentTag="AboutSusanHeader8241ed2e83c14846B14b568a9a24c9ca" {...props} />
  );
}

// id: "360eab8b-ce8b-47e1-b50a-e712bf2eeb04"
// title: "Header Top"
// type: :reference
// key: "header-top"
// parent_id: "50779257-8d27-47c2-a9b2-4431370d4865"
export function HeaderTop360eab8bCe8b47e1B50aE712bf2eeb04(props: any) {
  return (
    <DefaultHeaderTopB5234aa5200149828633C0843a2e5631 parentTag="HeaderTop360eab8bCe8b47e1B50aE712bf2eeb04" {...props} />
  );
}

// id: "f81cfd15-06fe-4d31-b478-964e25ca82f9"
// title: ""
// type: :reference
// key: "header"
// parent_id: "69aad7fa-ffa5-4475-9daf-462bae21f146"
export function HeaderF81cfd1506fe4d31B478964e25ca82f9(props: any) {
  return (
    <SecondaryMarketingHeaderFf13f5ff1cc74afc9e978aca6d362f18 parentTag="HeaderF81cfd1506fe4d31B478964e25ca82f9" title="Join Us" {...props} />
  );
}

// id: "52998451-420c-47f3-911d-b04c62b3c53b"
// title: ""
// type: :text
// key: "title"
// parent_id: "f81cfd15-06fe-4d31-b478-964e25ca82f9"
export const Title52998451420c47f3911dB04c62b3c53b = "Join Us";

// id: "c3ab918a-c9d5-449e-a75a-d9fa4d003802"
// title: "Marketing Cards"
// type: :gf_preset
// key: "marketing-cards"
// parent_id: nil
export function MarketingCardsC3ab918aC9d5449eA75aD9fa4d003802(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="MarketingCardsC3ab918aC9d5449eA75aD9fa4d003802" parentTag={buildClassName("MarketingCardsC3ab918aC9d5449eA75aD9fa4d003802", parentTag)} postSlug="home-page-posts2" buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" {...props} />
  );
}

// id: "c7e72468-9c1f-4b1c-a2bb-eadadf64905d"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "d13eadd8-a557-40c6-87c7-7e12a6aa3b39"
export function FooterC7e724689c1f4b1cA2bbEadadf64905d(props: any) {
  return (
    <DefaultFooterB9a00b217e8249fcA695Af3b462d34c9 parentTag="FooterC7e724689c1f4b1cA2bbEadadf64905d" {...props} />
  );
}

// id: "752ae84d-c5d8-49e5-b442-32fe13f55c3d"
// title: ""
// type: :text
// key: "alt"
// parent_id: "9a40158f-f690-4804-a82b-a700ff679a3a"
export const Alt752ae84dC5d849e5B44232fe13f55c3d = "logo";

// id: "3cc8fcb5-26e9-4b89-886a-e1945fc8721e"
// title: ""
// type: :html
// key: "about-susan-main"
// parent_id: "50779257-8d27-47c2-a9b2-4431370d4865"
export function AboutSusanMain3cc8fcb526e94b89886aE1945fc8721e(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} AboutSusanMain3cc8fcb526e94b89886aE1945fc8721e`}>
      <div className="background-image">
      </div>
      <div className="text-block first">
        <div className="opacity">
        </div>
        <div className="text">
          <h2 className="heading">
            Welcome to the house of Breath.
          </h2>
          <p>
            Here we can slow down, exhale the old, and breathe in the new.
          </p>
          <p>
            Are you looking for deeper ways to connect with yourself?
          </p>
          <p>
            Do you feel desire to experience MORE?
          </p>
          <p>
            More...
          </p>
          <p>
            pleasure, security, magic, wholeness...
          </p>
          <p>
            MORE TURNED ON WITH YOUR LIFE.
          </p>
          <p>
            Answer the beckoning of the heart,
          </p>
          <p>
            I&#39;m here to support you on this journey.
          </p>
        </div>
      </div>
      <div className="page-row color-scheme-1">
        <div className="text-block centered-page-content">
          <div className="text">
            <p className="heading">
              Discover the magic you behold
            </p>
            <p>
              When we get overwhelmed by life and navigate difficult situations, we
              can forget our own magic. Sometimes we are shut down and disconnected
              from our body, our pleasure, our purpose.
            </p>
            <p>
              It&#39;s okay to ask for help, it&#39;s my honor to help remind you. Let&#39;s
              take time to build trust and learn about what you are missing.
            </p>
            <p>
              Sacred space gives us an opportunity to loosen up tension in the body.
              Clear out old chakra patterns. Remember what it feels like to be your
              magical integrated self.
            </p>
            <p>
              House of Breath is a Temple. Serene, sensual, playful.
            </p>
            <div className="button-container">
              <a href="/about/offerings" className="Button transition">
                Explore my Offerings
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="image-block">
      </div>
      <div className="page-row color-scheme-1">
        <div className="text-block centered-page-content testimonials">
          <div className="heading">
            Testimonials
          </div>
          <div className="testimonial">
            <div className="image-container">
              <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/images/Shout.jpg" alt="photo of CK" />
            </div>
            <div className="text-container">
              <p>
                I felt a warm, tight feeling in my throat as Susan was working on
                opening my throat chakra. I thought of people who I let take my
                voice away and my inner self said &quot;NO MORE, This is my voice, I will
                speak my truth&quot;
              </p>
              <p>
                — CK
              </p>
            </div>
            <div className="bottom" />
          </div>
          <div className="testimonial">
            <div className="image-container">
              <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/images/Relaxation.jpeg" alt="photo of BB" />
            </div>
            <div className="text-container">
              <p>
                She has a loving intuition that meets you where you are. She helps
                you relax into healing yourself while allowing the possibilities of
                what your life can be to blossom.
              </p>
              <p>
                — BB
              </p>
            </div>
            <div className="bottom" />
          </div>
          <div className="testimonial">
            <div className="image-container">
              <img src="https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/images/Touch.jpg" alt="photo of CK" />
            </div>
            <div className="text-container">
              <p>
                Through her touch, Susan makes a visceral connection that reaches my
                core, sending reverberations throughout my body.
              </p>
              <p>
                — R
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="contact-small">
      </div>
      <div className="contact-container">
        <div className="contact-form block color-scheme-2">
          <div className="heading">
            Reach out for a free consultation!
          </div>
          <p>
            When you feel called to any of my services, it begins with a discovery
            call with SuSun. This is to make sure Tastes of Tantra is a good fit for
            yourself and your relationships!
          </p>
          <div className="button-container">
            <a href="/members/messages/x1RwUD7TogtZzODN" className="Button color2 transition">
              Message SuSun
            </a>
          </div>
        </div>
        <div className="image">
        </div>
      </div>
    </main>
  );
}

// id: "02ab2186-78b1-47fb-93c4-6394120fa1bf"
// title: ""
// type: :text
// key: "title"
// parent_id: "31605a88-a74c-437e-b0fb-967378dd631e"
export const Title02ab218678b147fb93c46394120fa1bf = "Leveling";

// id: "db47151d-c8ce-483e-bdd8-f04dadabb61c"
// title: "Home Page"
// type: :html
// key: "home-page"
// parent_id: nil
export function HomePageDb47151dC8ce483eBdd8F04dadabb61c(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePageDb47151dC8ce483eBdd8F04dadabb61c page`}>
      {props["header"] || <HomeHeaderB711eda121fe4b7aBd3222b963b4de32 parentTag="Header9b29935e3ae34e1aAc8939632a8603c7" {...props} />}
      {props["welcome-back"] || <WelcomeBackPopUp className="WelcomeBack12534a71868d4dd9Ac9948938e74401d" parentTag={buildClassName("WelcomeBack12534a71868d4dd9Ac9948938e74401d", parentTag)} {...props} />}
      {props["body"] || <MarketingBody4f325235Dec24e71988910b56c019d3b parentTag="Body4c686644D5e4463187ec2fb55a431764" {...props} />}
      {props["quote"] || <PageQuote className="QuoteAc510ae1Aff04ecd8cecBe2cf50d5029" parentTag={buildClassName("QuoteAc510ae1Aff04ecd8cecBe2cf50d5029", parentTag)} contentSlug="home-page-quote" {...props} />}
      {props["footer"] || <DefaultFooterB9a00b217e8249fcA695Af3b462d34c9 parentTag="Footer625b6d372a0643d19e3d069a7180d0ab" {...props} />}
    </div>
  );
}

// id: "5eabdceb-494b-4871-b346-6c626151af9b"
// title: ""
// type: :gf_preset
// key: "button"
// parent_id: "034360cc-e2fe-4d38-9d08-a7c120f73d74"
export function Button5eabdceb494b4871B3466c626151af9b(props: any) {
  const Button = AppStore.presets["Button"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Button className="Button5eabdceb494b4871B3466c626151af9b" parentTag={buildClassName("Button5eabdceb494b4871B3466c626151af9b", parentTag)} label="Join Us" href="/join" {...props} />
  );
}

// id: "9b9fa89e-e919-4832-b8f7-2ae6a7533bf3"
// title: ""
// type: :text
// key: "backgroundImage"
// parent_id: "b711eda1-21fe-4b7a-bd32-22b963b4de32"
export const BackgroundImage9b9fa89eE9194832B8f72ae6a7533bf3 = "https://mp1md-pub.s3.amazonaws.com/orgs/tastesoftantra/hero4.jpg";

// id: "fbc31c34-5837-44e6-b5f7-b2cd1925d497"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "09b837a8-af49-4859-a4a7-dffb76f18f3e"
export function FooterFbc31c34583744e6B5f7B2cd1925d497(props: any) {
  return (
    <DefaultFooterB9a00b217e8249fcA695Af3b462d34c9 parentTag="FooterFbc31c34583744e6B5f7B2cd1925d497" {...props} />
  );
}

// id: "9f5537e0-887d-4e03-b090-13b11f3dc965"
// title: ""
// type: :text
// key: "title"
// parent_id: "cceb18c2-ba54-49b1-8b34-5d92dbbe4d82"
export const Title9f5537e0887d4e03B09013b11f3dc965 = "Secondary Page";

// id: "4e5492e8-b681-4e25-a550-6c09c649a69a"
// title: ""
// type: :text
// key: "href"
// parent_id: "5eabdceb-494b-4871-b346-6c626151af9b"
export const Href4e5492e8B6814e25A5506c09c649a69a = "/join";

const Components = {
  HeaderF1bff543Ed4146ee99f716728f01ce75,
  PageQuote4c18bbf67bb541c9Bf14Dbcf371fc9d1,
  ImageUrl515eddabAeba49bfBee323eba9f299a8,
  Header0b8840485314476eB88952929b8e45df,
  CopyrightA395263dFd0946a1987348635843edbc,
  Href7214ba75Af144c26A095025201acaaa5,
  SecondaryPageDde117f073c543e886895f5136b41668,
  LinkedLogoEc8f9ff55976459480266ddc19150db1,
  HeaderA667f414A0634a6eAc5a6e7f0b0a5fd4,
  Navigation4507bff675c24453A4055ab11b37f7f2,
  PostSlug4f9789185af2436385fc72f82d07a120,
  MemberPagesOldD13eadd8A55740c687c77e12a6aa3b39,
  ResourcesPage769bf0842c3a420bB2bf318376630914,
  Hero188610ca930e403d8863F8e9799c8560,
  NavMenuSlug67d1d8b555c34ce2Bc3bF4bffb4c5895,
  AboutSusanHeaderB1d307ebDd5e47bcBbf61e6d06d18d47,
  Title7506062024994ba9A93bB4df5d4be877,
  DefaultHeaderTopB5234aa5200149828633C0843a2e5631,
  TitleCb41a40574d94f1eB6f601b62463bb4c,
  Header31605a88A74c437eB0fb967378dd631e,
  SecondaryNav3c621cebC9e940edBf7fD2d1cb4f710d,
  HeaderFe8f974f1acc4d27859dAb43d2cf8bba,
  LabelCe67ad5076c74592A4291fae4798fa80,
  MarketingBody4f325235Dec24e71988910b56c019d3b,
  DefaultHeader1b86edb87dc44312B5deE8e8efc1d529,
  Navigation0f4a01d9Eb64446083570d55736406a4,
  Footer625b6d372a0643d19e3d069a7180d0ab,
  TitleB144fea094834f6081268609fe0f78da,
  NavMenuSlugFa1d0c930cbc4f13A7cd3f0b37388a6a,
  AboutLevelingPageA5ddd4b7Ba7f4735A4297a449ece0334,
  Label91cc17df7a7641daA6a9F1dacfec7234,
  Footer774a12726ba44062A5f2Ec68a8a32872,
  Groupflow64937f15F98d4dc3Ab4e33d2dae1ddcd,
  Class33717523C6294c0783777714c3c75039,
  TitleFc82126535b04ce598009d9a5d2fb2d2,
  SignupPages3a700b3eC55246c58fc1E625486e3bb6,
  DefaultLogo9a40158fF6904804A82bA700ff679a3a,
  HeaderTopA1d0821bCb49476fA45802d5c9d2a313,
  Header08c096b1815946d5A519A7bac5576191,
  HeaderCceb18c2Ba5449b18b345d92dbbe4d82,
  Label70e84cf7D6594080B66b3b96e7e42793,
  PublicEventsPageA8475aa2Dc804f1e871362bfc4a29b72,
  Footer4819020dD610438b8756703ad978c965,
  HeaderDb95b1511481480dB1a8B8dd98356abe,
  LinksF6c6f806C06c4dc598f742b1d0763833,
  NavMenuSlug712b1506C6f24dc087edF04cf71ea86c,
  NavigationE7956cc5D56846e4Bbe1E6e304e1ad5e,
  SecondaryMarketingHeroF1bf4a81C5af4023A0ffAbd8a030fd01,
  MembersAreaDefault5bac77e0Bda74d29815991e68fe983a9,
  TitleE8b4400d95bc40998e6cDca572de4683,
  PostSlug5e72c7da244a4021A075Cf6b5324633e,
  Footer86173d9044ad40e98d81604d7f342d83,
  Class29efaffeE5ae49f2A3270da81d392200,
  AboutSusan507792578d2747c2A9b24431370d4865,
  DefaultFooterB9a00b217e8249fcA695Af3b462d34c9,
  Footer43b58726A1dd4aa7B6508e36196c85b4,
  TitleE2af129bB74f4574A469A64caf91a0da,
  Header036b0af06c8246589560645fdd168f7e,
  PostSlug098a96aeF18e4e00B9fdD492c811497a,
  MessagePagesC37d6664417945ddA3d1B43b3612995a,
  HomeHeaderB711eda121fe4b7aBd3222b963b4de32,
  Body33f21fb58bf54a78B70d26bba085a133,
  MarketingCardsDd00a35bA72e476cA66217669324f3e3,
  Class6d598c8a41704c71A8a0A0f2dd658270,
  Title74974fdd06c446a7B42a467ba73e0764,
  AdminPages9147cb141940475590fb2a8679bd6409,
  MembersAreaHeaderOld0548d6690a6243adB811148734b32b3e,
  WelcomeBack12534a71868d4dd9Ac9948938e74401d,
  Hero908c32106779438b946d3325ecfe7deb,
  Title8acb1836Df3d4f4f9b1700b34517d2ad,
  LabelDb0e1889F1b44e2e925077af53fc0e11,
  HomePageHero034360ccE2fe4d389d08A7c120f73d74,
  Logo0f83c49f9a904a9d99fc33d0d04e8d42,
  Footer69a9596e8f54414fAbbbDcdce21d3c53,
  Footer3b5faa7848bb43b3A6f99926730e4eb3,
  ContentSlug7abee52bA7d946bfAb4e17a34e9f614e,
  NavMenuSlug436925b1Eabd40beAcfcDf9ab5db1a51,
  AboutOfferings5c0d118762794370Bd5aA4682f2be444,
  NavMenuSlugA6cce9854b404d3a837b4c5a277a4177,
  HeaderTopEcc3dedaFc134e4e832a86ce938f64fc,
  Body4c686644D5e4463187ec2fb55a431764,
  Url031cd02b39bf4e12A8cb693e50614586,
  NavMenuSlugE5cadda3300c4bbaA60e33221300c53a,
  SecondaryMarketingHeaderFf13f5ff1cc74afc9e978aca6d362f18,
  Header9b29935e3ae34e1aAc8939632a8603c7,
  LinkedLogoBf3b582301154f188e0a1f5ada16e19c,
  Header85c50bb1Cd194dafA90fC0eeaca4365c,
  NavMenuSlugC021d4ddDd44404093ec0ae8e146e41f,
  NavMenuSlug5e225e74C0b44ce0B8b61d4365d44acb,
  JoinUsPage69aad7faFfa544759daf462bae21f146,
  QuoteAc510ae1Aff04ecd8cecBe2cf50d5029,
  HeaderTopC2b32e8eB6354154A71f673669341357,
  Title22e9494765f34eaaAe11808ddc995016,
  Class5321731b68874811Bbbd01f7e7a5f86e,
  AboutUsPage09b837a8Af494859A4a7Dffb76f18f3e,
  BackgroundImageD3a0e07fF7024472B12f80a85b8c0a95,
  Footer8574ba822bbf431fB71491021a2f440c,
  ButtonClassEf11f2a037a54206Adfc286089568307,
  PostSlugBe6a53f45c0641a39a833bf0189bac33,
  ShortHeader0653a704D4574b09Aa9b74718f56cea7,
  AboutSusanHeader8241ed2e83c14846B14b568a9a24c9ca,
  HeaderTop360eab8bCe8b47e1B50aE712bf2eeb04,
  HeaderF81cfd1506fe4d31B478964e25ca82f9,
  Title52998451420c47f3911dB04c62b3c53b,
  MarketingCardsC3ab918aC9d5449eA75aD9fa4d003802,
  FooterC7e724689c1f4b1cA2bbEadadf64905d,
  Alt752ae84dC5d849e5B44232fe13f55c3d,
  AboutSusanMain3cc8fcb526e94b89886aE1945fc8721e,
  Title02ab218678b147fb93c46394120fa1bf,
  HomePageDb47151dC8ce483eBdd8F04dadabb61c,
  Button5eabdceb494b4871B3466c626151af9b,
  BackgroundImage9b9fa89eE9194832B8f72ae6a7533bf3,
  FooterFbc31c34583744e6B5f7B2cd1925d497,
  Title9f5537e0887d4e03B09013b11f3dc965,
  Href4e5492e8B6814e25A5506c09c649a69a
}

export default Components;